import { INote, INoteListState, INoteState } from 'entities/Notes/Note.models';

export const noteListReducers = {
  setList: (state: INoteListState, payload: INote[]) => ({ ...state, data: payload }),
  setLoading: (state: INoteListState, payload: boolean) => ({ ...state, loading: payload }),
};

export const noteReducers = {
  setNote: (state: INoteState, payload: INote) => ({ ...state, data: payload }),
  setLoading: (state: INoteState, payload: boolean) => ({ ...state, loading: payload }),
};
